import React from 'react';
import {
  faSquareMinus,
  faSquareCheck,
  faSquareXmark,
  faSquareEllipsis,
  faSquare,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TEN_DLC_STATUS_ICON_CONFIG = {
  suspended: {
    icon: faSquareMinus,
    style: { color: 'D41C54' },
  },
  registered: {
    icon: faSquareCheck,
    style: { color: '009B7C' },
  },
  approved: {
    icon: faSquareCheck,
    style: { color: '009B7C' },
  },
  rejected: {
    icon: faSquareXmark,
    style: { color: 'black' },
  },
  review: {
    icon: faSquareEllipsis,
    style: { color: '00698F' },
  },
};

const RCS_STATUS_ICON_CONFIG = {
  active: {
    icon: faSquareCheck,
    style: { color: '009B7C' },
  },
  suspended: {
    icon: faSquareMinus,
    style: { color: 'B70505' },
  },
  rejected: {
    icon: faSquareXmark,
    style: { color: '090404' },
  },
  terminated: {
    icon: faSquare,
    style: { color: '090404' },
  },
};

const getStatusIcon = (status, channel = '10DLC') => {
  const maps = {
    '10DLC': TEN_DLC_STATUS_ICON_CONFIG,
    RCS: RCS_STATUS_ICON_CONFIG,
  };
  const config = maps[channel]?.[status.toLowerCase()];
  const iconSize = channel === '10DLC' ? 'xl' : '12px';
  if (config) {
    return <FontAwesomeIcon size={iconSize} {...config} />;
  }
  return undefined;
};

export { getStatusIcon };
